import { render, staticRenderFns } from "./SplitPanelA.vue?vue&type=template&id=19a47504&scoped=true&"
import script from "./SplitPanelA.vue?vue&type=script&lang=js&"
export * from "./SplitPanelA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a47504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a47504')) {
      api.createRecord('19a47504', component.options)
    } else {
      api.reload('19a47504', component.options)
    }
    module.hot.accept("./SplitPanelA.vue?vue&type=template&id=19a47504&scoped=true&", function () {
      api.rerender('19a47504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/modules/SplitPanelA.vue"
export default component.exports